import { createFileRoute } from '@tanstack/react-router';

import { CreativesPage } from '../features/campaigns/creatives/CreativesPage';
import { creativesRouteSearchSchema } from '../features/campaigns/creatives/creativesRouteSearch';
import { CreativeTab } from '../features/campaigns/creatives/model';

export const Route = createFileRoute('/campaigns/creatives_/display')({
  validateSearch: creativesRouteSearchSchema,
  component: DisplayCreativesRoute,
});

function DisplayCreativesRoute() {
  return <CreativesPage tab={CreativeTab.Display} />;
}
